export const DEPENDENCY_SEARCH_PLACEHOLDER = 'Search or choose predecessor';
